import { render, staticRenderFns } from "./ErrorPayment.vue?vue&type=template&id=4b605c82&scoped=true"
import script from "./ErrorPayment.vue?vue&type=script&lang=js"
export * from "./ErrorPayment.vue?vue&type=script&lang=js"
import style0 from "./ErrorPayment.vue?vue&type=style&index=0&id=4b605c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b605c82",
  null
  
)

export default component.exports